import { TimerWidget } from "./-components/TimerWidget"
import { TypistWidget } from "./-components/typistWidget"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { useQuery } from "convex/react"

import type { Id } from "@convex/_generated/dataModel"
import { api } from "@convex/_generated/api"

export const Route = createFileRoute("/(app)/app/quizzes/$quizStateId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { quizStateId } = Route.useParams()

  // Fetch quiz state by ID (includes quiz details)
  const data = useQuery(api.quizState.handlers.getQuizStateById, {
    quizStateId: quizStateId as Id<"quizState">,
  })

  // Fetch current user
  const currentUser = useQuery(api.users.handlers.current)

  const quizState = data?.quizState
  const quiz = data?.quiz

  // Check if this is a team quiz (only team quizzes have timers)
  const displayTimer = quiz?.type === "teams" || quiz?.type === "pairs" || quiz?.type === "specialist" || quiz?.type === "champions"

  return (
    <div className="container mx-auto max-w-4xl space-y-8 p-6">
      {/* Render TypistWidget for team quizzes with active quiz state */}
      {quizState && quizState.teamId && currentUser && (
        <TypistWidget
          quizStateId={quizState._id}
          teamId={quizState.teamId}
          currentUserId={currentUser._id}
          typistId={quizState.typistId}
        />
      )}
      {/* Render TimerWidget only for quizzes when a round is active */}
      {displayTimer &&
        quizState &&
        quizState.currentRound > 0 &&
        (quizState.status === "in-progress" || quizState.status === "idle") && (
          <TimerWidget quizState={quizState} />
        )}
      <Outlet />
    </div>
  )
}
